import React from 'react';
import { Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.home, href: '#hero' },
    { label: t.nav.sidekicks, href: '#sidekicks' },
    { label: t.nav.flow, href: '#flow' },
    { label: t.nav.why, href: '#why' },
    { label: t.nav.faq, href: '#faq' },
  ];

  return (
    <footer className="bg-ink text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span
                className="w-9 h-9 bg-mint flex items-center justify-center text-white font-display font-bold text-sm"
                aria-hidden
              >
                PS
              </span>
              <span className="text-xl font-display font-bold tracking-tight">Pixel Sidekicks</span>
            </div>
            <p className="text-white/55 text-sm leading-relaxed mb-4 max-w-md">{t.footer.blurb}</p>
            <p className="text-white/35 text-xs leading-relaxed max-w-lg">{t.footer.legalShort}</p>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.18em] mb-5">
              {t.footer.navTitle}
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/55 hover:text-mint-soft transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-[0.18em] mb-5">
              {t.footer.contactTitle}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:support@pixelsidekicks.com"
                  className="flex items-center gap-2 text-white/55 hover:text-mint-soft transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  support@pixelsidekicks.com
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <a
                href="/s"
                className="inline-flex items-center bg-ember hover:bg-ember-deep text-white px-5 py-2.5 font-bold text-sm transition-colors"
              >
                {t.footer.cta}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/35 text-xs text-center md:text-left">
            &copy; {new Date().getFullYear()} {t.footer.copyright}
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <a href="/agb.html" className="text-white/35 hover:text-mint-soft transition-colors text-xs">
              {t.footer.agb}
            </a>
            <a
              href="/datenschutz.html"
              className="text-white/35 hover:text-mint-soft transition-colors text-xs"
            >
              {t.footer.privacy}
            </a>
            <a href="/hilfe.html" className="text-white/35 hover:text-mint-soft transition-colors text-xs">
              {t.footer.help}
            </a>
            <a
              href="/impressum.html"
              className="text-white/35 hover:text-mint-soft transition-colors text-xs"
            >
              {t.footer.imprint}
            </a>
            <a
              href="/widerruf.html"
              className="text-white/35 hover:text-mint-soft transition-colors text-xs"
            >
              {t.footer.widerruf}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
